/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBookingInfoDto } from './order-booking-info-dto';
import {
    OrderBookingInfoDtoFromJSON,
    OrderBookingInfoDtoFromJSONTyped,
    OrderBookingInfoDtoToJSON,
    OrderBookingInfoDtoToJSONTyped,
} from './order-booking-info-dto';
import type { OrderSystemInfoDto } from './order-system-info-dto';
import {
    OrderSystemInfoDtoFromJSON,
    OrderSystemInfoDtoFromJSONTyped,
    OrderSystemInfoDtoToJSON,
    OrderSystemInfoDtoToJSONTyped,
} from './order-system-info-dto';

/**
 * 
 * @export
 * @interface SubmitOrderBookingInfoRequestDto
 */
export interface SubmitOrderBookingInfoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SubmitOrderBookingInfoRequestDto
     */
    idempotenceKey: string;
    /**
     * 
     * @type {OrderSystemInfoDto}
     * @memberof SubmitOrderBookingInfoRequestDto
     */
    systemInfo: OrderSystemInfoDto;
    /**
     * 
     * @type {OrderBookingInfoDto}
     * @memberof SubmitOrderBookingInfoRequestDto
     */
    bookingInfo: OrderBookingInfoDto;
}

/**
 * Check if a given object implements the SubmitOrderBookingInfoRequestDto interface.
 */
export function instanceOfSubmitOrderBookingInfoRequestDto(value: object): value is SubmitOrderBookingInfoRequestDto {
    if (!('idempotenceKey' in value) || value['idempotenceKey'] === undefined) return false;
    if (!('systemInfo' in value) || value['systemInfo'] === undefined) return false;
    if (!('bookingInfo' in value) || value['bookingInfo'] === undefined) return false;
    return true;
}

export function SubmitOrderBookingInfoRequestDtoFromJSON(json: any): SubmitOrderBookingInfoRequestDto {
    return SubmitOrderBookingInfoRequestDtoFromJSONTyped(json, false);
}

export function SubmitOrderBookingInfoRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitOrderBookingInfoRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idempotenceKey': json['idempotenceKey'],
        'systemInfo': OrderSystemInfoDtoFromJSON(json['systemInfo']),
        'bookingInfo': OrderBookingInfoDtoFromJSON(json['bookingInfo']),
    };
}

  export function SubmitOrderBookingInfoRequestDtoToJSON(json: any): SubmitOrderBookingInfoRequestDto {
      return SubmitOrderBookingInfoRequestDtoToJSONTyped(json, false);
  }

  export function SubmitOrderBookingInfoRequestDtoToJSONTyped(value?: SubmitOrderBookingInfoRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempotenceKey': value['idempotenceKey'],
        'systemInfo': OrderSystemInfoDtoToJSON(value['systemInfo']),
        'bookingInfo': OrderBookingInfoDtoToJSON(value['bookingInfo']),
    };
}

